import { render } from "./AlarmUserSetting.vue?vue&type=template&id=f38714bc&scoped=true"
import script from "./AlarmUserSetting.vue?vue&type=script&lang=js"
export * from "./AlarmUserSetting.vue?vue&type=script&lang=js"

import "./AlarmUserSetting.vue?vue&type=style&index=0&id=f38714bc&lang=scss"
import "./AlarmUserSetting.vue?vue&type=style&index=1&id=f38714bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f38714bc"],['__file',"src/containers/event/eventSettings/components/AlarmUserSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f38714bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f38714bc', __exports__)) {
    api.reload('f38714bc', __exports__)
  }
  
  module.hot.accept("./AlarmUserSetting.vue?vue&type=template&id=f38714bc&scoped=true", () => {
    api.rerender('f38714bc', render)
  })

}


export default __exports__